import { useContext, useEffect, useRef } from 'react';
import { GlobalContext } from "../contexts/globalContext"
import io from "socket.io-client"


const SocketManager = () => {
    const {
        setIoSettings, localSocketRef,
        iamRoomAdministrator, socketToken, setCurrentTopic, setTopics, setCurrentParticipantStream, currentParticipant, setConferencePaused, currentConference, deskData,
        setCurrentConference, setCurrentParticipant, setWaitingForJoining, setSharedFiles, setOpenedFiles, selectedTopicIdRef, setTopicFiles, devices, socketRef, setAllUsers,
        setDetailsUpcomingConference, selectedProject, setSelectedProject, currentUser, setProjectsList, statusProjectList, setIamRoomAdministrator,
    } = useContext(GlobalContext);


    const devicesRef = useRef();
    const selectedProjectIDRef = useRef();

    const currentConferenceRef = useRef();
    const deskDataRef = useRef();
    const currentParticipantRef = useRef();

    const iamRoomAdministratorRef = useRef();


    useEffect(() => {
        iamRoomAdministratorRef.current = iamRoomAdministrator;
    }, [iamRoomAdministrator])

    useEffect(() => {
        currentConferenceRef.current = currentConference;
        deskDataRef.current = deskData;
        currentParticipantRef.current = currentParticipant;
    }, [currentConference, deskData, currentParticipant])

    useEffect(() => {
        devicesRef.current = devices;
    }, [devices])

    useEffect(() => {
        selectedProjectIDRef.current = selectedProject?._id;
    }, [selectedProject])

    useEffect(() => {
        socketRef.current = io.connect(process.env.REACT_APP_CMS_URL, {
            secure: true,
            reconnect: true,
            rejectUnauthorized: true,
            query: { token: socketToken }
        })

        socketRef.current.on('connect', function () {
            if (deskDataRef.current) {
                socketRef.current.emit("DEVICE_ONLINE", deskData.deviceId);
                socketRef.current.emit("JOIN_ROOM", deskData.room._id);
            }

            socketRef.current.emit("GET_ALL_USERS", (users) => {
                setAllUsers(users)
            });

            socketRef.current.on("YOU_ARE_ADMIN_OF_THE_ROOM", () => {
                if (localSocketRef.current?.connected && deskData && !iamRoomAdministratorRef.current) {
                    localSocketRef.current.emit("volume:reconnectDante", deskData.number);
                    setIamRoomAdministrator(true);
                }
            });

            socketRef.current.on("YOU_ARE_NOT_ADMIN_OF_THE_ROOM_ANYMORE", () => {
                setIamRoomAdministrator(false);
            });

            socketRef.current.on("SHUTDOWN", async () => {
                if (localSocketRef.current?.connected) {
                    localSocketRef.current.emit("systemInfo:shutdown");
                }
            });

            socketRef.current.on('REFRESH_PROJECTS', (participantIds) => {
                const participantId = currentUser?._id;

                if (participantIds.includes(participantId)) {
                    socketRef.current.emit('GET_ALL_PROJECTS', participantId, null, statusProjectList, (projects) => {
                        setProjectsList(projects);
                    });
                }
            });

            socketRef.current.on('REFRESH_PROJECT', (projectId) => {
                if (selectedProjectIDRef.current && selectedProjectIDRef.current === projectId) {
                    socketRef.current.emit("GET_PROJECT_BY_ID", { projectId: selectedProjectIDRef.current, selectedTopicId: selectedTopicIdRef.current }, (project, conference, topicFiles) => {
                        setSelectedProject(project)
                        setDetailsUpcomingConference(conference)
                        setTopicFiles(topicFiles)

                        if (project.topics.length > 0 && !selectedTopicIdRef.current) {
                            selectedTopicIdRef.current = project.topics[0]._id;
                        }
                    })
                }
            });

            socketRef.current.on('DESK_PARTICIPANT_CHANGED', function (deskId) {
                console.log("DESK_PARTICIPANT_CHANGED 1");
                if (deskDataRef.current && deskDataRef.current._id == deskId) {
                    socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskDataRef.current._id, (data) => {
                        if (!data.error && data.conference && data.conference.millisUntilStart <= 10) {
                            console.log("DESK_PARTICIPANT_CHANGED 2");
                            setWaitingForJoining(true);
                            setCurrentParticipant(data.participant);
                            setCurrentConference(data.conference);
                            setConferencePaused(data.conference.paused);
                        } else {
                            setIoSettings(null);
                            setWaitingForJoining(true);


                            console.log("DESK_PARTICIPANT_CHANGED 3", data.conference);


                            setCurrentConference(null);
                            setCurrentParticipantStream(null);
                            setCurrentTopic(null);
                            setTopics();

                            setCurrentParticipant(null);
                        }
                    });
                }
            });

            socketRef.current.on('CONFERENCE_STOPED', function (conference) {
                console.log("CONFERENCE_STOPED")
                if (currentConferenceRef.current) {
                    if ((currentConferenceRef.current && currentConferenceRef.current._id === conference._id) ||
                        (deskDataRef.current && conference.rooms.includes(deskDataRef.current._id))) {

                        if (currentConferenceRef.current.type === "Presentation" && conference.status === "New" && currentParticipantRef.current?._id === currentConferenceRef.current.moderatedBy) {
                            setSharedFiles([]);
                            setOpenedFiles([]);
                            setCurrentConference((conf) => ({ ...conf, roomAdmins: conference.roomAdmins, status: "New" }));
                        } else {
                            setSharedFiles([]);
                            setOpenedFiles([]);
                            setCurrentConference(null);
                            setCurrentParticipant(null);
                            setCurrentParticipantStream(null);
                            setCurrentTopic(null);

                            setTopics();
                            setWaitingForJoining(true);
                        }
                    }
                }
            });

            socketRef.current.on('REFRESH_CONFERENCE_TOPICS', function (conferenceId, _) {
                if (currentConferenceRef.current && currentConferenceRef.current._id === conferenceId) {

                    socketRef.current.emit("GET_CONFERENCE_BY_ID", conferenceId, (callback) => {
                        if (!callback.error) setTopics(callback.response.topics);
                    })
                }
            });
        });


        return () => {
            socketRef.current.disconnect()
            socketRef.current = null
        }
    }, [])

    return (
        <> </>
    );
}

export default SocketManager;